<template>  
     <div class="custom-control custom-radio">  

        <input  
            type="radio" 
            class="custom-control-input e2e-radiobutton"
            :class="fragment.semanticInvalid?'is-invalid':''"
            :id="fragment.uuid"
            :disabled="!fragment.editable" 
            :name="fragment.groupUuid"  
            :checked="selected" 
            :value="fragment.uuid"> 

        <label :for="fragment.uuid" class="custom-control-label">
            <i v-if="fragment.semanticInvalid === true  && fragment.selected" class="fa fa-times" style="color: red" aria-hidden="true"></i>
            <i v-if="fragment.semanticInvalid === false && fragment.selected" class="fa fa-check" style="color: lime" aria-hidden="true"></i>
            <div  :fragment="fragment.label"
                  :is="resolveFragmentComponentName(fragment.label)">
            </div>
        </label>
  
        <input  type="hidden"  
                v-if="selected===true && !fragment.editable"
                :name="fragment.groupUuid" 
                :value="fragment.uuid"> 

        <!-- allways keep track of group -->
        <input  type="hidden"  
                :name="fragment.groupUuid" 
                :value="fragment.groupUuid"> 
 
        <div class="invalid-feedback" v-if="fragment.semanticInvalid" >
          {{fragment.semanticInvalidMessage}}
        </div>
    </div> 
</template>

<script>
import { resolveFragmentComponentName } from "./output-fragment-resolver.js";

export default {
  name: "fragment-radiobutton",
  props: ["fragment"],
  data:function(){
    return {
      selected: false 
    };
  },
  methods: {
    resolveFragmentComponentName
  },
  mounted(){
    this.selected = this.fragment.selected ? true : false;
  }
};
</script>
 

<style scoped>
</style>